import React, { useState } from "react";
import Button from '@mui/material/Button';
import { amplify } from "../../service/api/AuthService";


const ChangePassOk = () => {

    const handleClickSignOut = () => {
        amplify.signOut();
      };

    const [modalOpen, setModalOpen] = useState(false);

    const handleCloseModal = () => {
        setModalOpen(false);
    }

    return (
        <>
            {(
                <div
                    open={modalOpen}
                    onClose={handleCloseModal}
                    className="modal-container">
                    <div className="pop-up-modal-ok col-sm-10 col-xl-6 container">
                     
                        <div className="row mt-xl-5 pt-xl-5 pt-5 pb-3">
                            <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M44 0c24.3 0 44 19.7 44 44S68.3 88 44 88 0 68.3 0 44 19.7 0 44 0zm0 4C21.909 4 4 21.909 4 44s17.909 40 40 40 40-17.909 40-40S66.091 4 44 4zm18.478 28a2 2 0 0 1 .034 2.828L40.607 57.274a3.001 3.001 0 0 1-4.196.096L25.095 46.792a2 2 0 1 1 2.732-2.922l10.6 9.909 21.222-21.745A2.002 2.002 0 0 1 62.478 32z" fill="#00CE49" />
                            </svg>
                        </div>

                        <div className="col-8 offset-2 text-center mt-4">
                            <h2>Has cambiado la
                                contraseña</h2>
                        </div>

                        <div className="row">
                            <div className="col-8 offset-2 text-center mt-2">
                                <p>Ya puedes acceder con tu nueva clave.</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            <Button onClick={handleClickSignOut}>
                                <span className="btn-inicio col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-sm-5">Ir al inicio</span>
                            </Button>
                        </div>
                    </div>
                </div >
            )}
        </>
    );
}

export default ChangePassOk;
